export enum ScriptType {
    // 只有一个脚本执行文件，它只在脚本列表里显示。
    // 如果要修改或者配置参数，它可以嵌入到自己的代码里
    // 或者提供新的页面路径，用router的方式打开
    // 例如router.go({url:'/script-setting', script:'function(){//code is here}', pagePath:'/all-script-setting/#your-namespace/script/script001'})
    // all-script-setting所有第三方统一页面
    // your-namespace 第三方自己的命名空间
    // url 第三方自己的js文件url，它和script二选一，优先script。
    // script 第三方自己纯代码的脚本
    // url可以设置为实时更新版本，script可以作为stable版本使用。
    // script001 第三方自己的脚本名称
    // pagePath可以挂载到你指定的路径下
    Script = 'script',
    Market = 'market'
}
export enum WatchResourceType {
    // 这是一个js文件，加载后直接套在iframe里用即可
    Js = 'js',
    // 这是一个html文件，直接当html加载到iframe里即可.
    Html = 'html'
}

export enum IMarketDevConnectEventType{
    getAllScripts = 'getAllScripts'
}
// client用socket向server发送的消息，也就是安卓端或者是安卓端的网页向server发送的消息
export enum IMarketDevClientEmitEventType{
    init = 'init'
}
// server用socket向安卓端发送的消息（本地调试也可以认为是向安卓的网页发送消息）
export enum IMarketDevServerEventType{
    update = 'update',
}

// export interface IMarketDevFileUpdateEventData{
//     filePath:string,
//     conf:IClientWatchFile
// }

export interface IMarketDevFileUpdateEvent extends IMarketDevEvent<IAndroidWatchFile>{
    type: IMarketDevServerEventType.update,
    data:IAndroidWatchFile
}

export interface IMarketDevGetAllEventData{
    resources:IAndroidWatchFile[]
    htmls:IAndroidWatchFile[]
}
export interface IMarketDevGetAllEvent extends IMarketDevEvent<IMarketDevGetAllEventData>{
    type: IMarketDevConnectEventType.getAllScripts,
    data:IMarketDevGetAllEventData
}
export type IMarketDevEventType = IMarketDevConnectEventType | IMarketDevClientEmitEventType | IMarketDevServerEventType;
export interface IMarketDevEvent<T>{
    type: IMarketDevEventType,
    data:T
}
type NamespaceType = string;
export interface IScriptFile{

    // 命名空间 用于识别唯一对象
    // 每个用户用自己的用户名做命名空间
    // 例如
    // 0xFF336699/e-commerce
    ns:NamespaceType
    resourceType:WatchResourceType
    scriptType:ScriptType
    // 通过网络加载的路径
    url?:string;
}

export interface IClientWatchFile extends IScriptFile{
    // 本地加载的路径
    path:string;
    //是否是ui模式输出，如果是ui模式输出则需要export {ScriptItem, MarketItem, MarketPage}当中之一或全部。
    // isUi:boolean
}
export interface IClientScriptConf extends IClientWatchFile{
}

export interface IClientHtmlConf extends IClientWatchFile{
    resourcesPath:string
    resourcesUrl:string
}

export interface IAndroidWatchFile{
    client:IClientWatchFile
    content:string
}

// 脚本文件map，这里是打散的，并没有按照开发者的ns分类，而是按照文件名分类
// 也就是文件名当作分类了。开发者有个ns，但是一个开发者可以开发n个market
// 所以用开发者的ns做限定是不够用的，现在想的是开发者ns+market or script做market的限定
// 所以这个ns应该是：
// `${developerNs}/markets/${market}`
// `${developerNs}/markets/${market}/${script}`
// `${developerNs}/scripts/${script}`
// 这种格式，回头可以用分段的方式来截取对象
export type ScriptMap = Record<NamespaceType, IAndroidWatchFile>;